import { render, staticRenderFns } from "./TableChatListItem.vue?vue&type=template&id=84b878e6&scoped=true"
import script from "./TableChatListItem.vue?vue&type=script&lang=ts"
export * from "./TableChatListItem.vue?vue&type=script&lang=ts"
import style0 from "./TableChatListItem.vue?vue&type=style&index=0&id=84b878e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b878e6",
  null
  
)

export default component.exports